import { StaticImage } from '@/common/constants/displateRoutes';
import { PageConfig, RouteBuilder, RouteOptions } from '@/common/routes/RouteBuilder';

/**
 * @returns '/following'
 */
export const RouteToFollowingPage = (options?: RouteOptions) => {
  return RouteBuilder({ ...options, path: '/following', target: 'elysium' });
};
export const FollowingPageConfig: PageConfig = {
  readableName: 'Following',
  analyticsGaName: 'following',
  analyticsAthenaName: 'following',
  pagePathnames: ['/following'],
  displayPromoBar: true,
  defaultMeta: {
    title: `Following | Displate`,
    description: `Followed artists and collections on Displate.`,
    coverImage: StaticImage('/images/following/og_image.jpg'),
  },
};
